export default __webpack_public_path__ + "static/media/email-notification.f04eb40b.svg";